module.exports = __webpack_public_path__ + "assets/img/00.2d2035ea.png";